import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import CreateNewRegion from '../CreateNewRegion';
import LUportBlock from './LUportBlock';
import DateRangeSelector from 'components/Base/DateRangeSelector';

import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';

import { updateCargoOrder } from 'actions/cargoes/orders';

import { MenuItem, SelectField, TextField } from 'material-ui';
import { LAYCAN_TYPES } from 'constants/layCan';

const getValueByLayCanType = key => LAYCAN_TYPES.find(i => i.key === key);

class LUports extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialogs: {},
            loadingPortsMap: props.cargoOrder.loadingPortsMap,
            unloadingPortsMap: props.cargoOrder.unloadingPortsMap,
        };

        props.cargoOrder.loadingPortsMap &&
            props.cargoOrder.loadingPortsMap.forEach((_port, index) => { this.state.openDialogs[`dialog${index}`] = false; });

        this.addNewPort = this.addNewPort.bind(this);
        this.removePort = this.removePort.bind(this);

        this.changePort = this.changePort.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.cargoOrder.loadingPortsMap !== this.state.loadingPortsMap) {
            this.setState({ loadingPortsMap: newProps.cargoOrder.loadingPortsMap });
        }

        if (newProps.cargoOrder.unloadingPortsMap !== this.state.unloadingPortsMap) {
            this.setState({ unloadingPortsMap: newProps.cargoOrder.unloadingPortsMap });
        }
    }

    changePort(key, type, port) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        if (type === 'loading') {
            newCargoOrder.loadingPortsMap[key] = {
                ...newCargoOrder.loadingPortsMap[key],
                port: {
                    ...newCargoOrder.loadingPortsMap[key].port,
                    ...port,
                },
            };
        } else {
            newCargoOrder.unloadingPortsMap[key] = {
                ...newCargoOrder.unloadingPortsMap[key],
                port: {
                    ...newCargoOrder.unloadingPortsMap[key].port,
                    ...port,
                },
            };
        }

        if (port.readinessDate !== undefined) {
            newCargoOrder.readinessDate = port.readinessDate;
        }
        if (port.cancellingDate !== undefined) {
            newCargoOrder.cancellingDate = port.cancellingDate;
        }
        if (port.validUntil !== undefined) {
            newCargoOrder.validUntil = port.validUntil;
        }

        if (type === 'loading') {
            if (
                !newCargoOrder.loadingPortsMap[key].port.readinessDate ||
                !newCargoOrder.loadingPortsMap[key].port.cancellingDate
            ) {
                newCargoOrder.validateErrors.push({
                    field: 'laycan',
                    messages: ['Readiness/cancelling date required'],
                });
            } else {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors
                    .filter(obj => obj.field !== 'laycan');

                newCargoOrder.validateErrors = newCargoOrder.validateErrors
                    .filter(obj => obj.field !== 'readinessDate');
                newCargoOrder.validateErrors = newCargoOrder.validateErrors
                    .filter(obj => obj.field !== 'cancellingDate');
            }
        }

        if (port.andOr) {
            newCargoOrder[`${type}PortsMap`][key] = {
                port,
                sign: port.andOr.toLowerCase(),
            };
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    removePort(key, type) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        if (type === 'loading') {
            newCargoOrder.loadingPortsMap.splice(key, 1);
        } else {
            newCargoOrder.unloadingPortsMap.splice(key, 1);
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    addNewPort(type) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        if (type === 'loading') {
            const firstLPort = this.state.loadingPortsMap[0];
            newCargoOrder.loadingPortsMap.push({
                port: {
                    port: '',
                    portName: '',
                    details: '',
                    cancellingDate: firstLPort.port.cancellingDate,
                    readinessDate: firstLPort.port.readinessDate,
                    validUntil: firstLPort.port.validUntil,
                    loadingPortDetails: '',
                    andOr: 'and',
                    additionalLayCanDetails: undefined,
                    layCanType: 'layCan',
                },
                sign: 'and',
            });
        } else {
            newCargoOrder.unloadingPortsMap.push({
                port: {
                    portName: '',
                    port: '',
                    details: '',
                    andOr: 'and',
                },
                sign: 'and',
            });
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    handleOpen = (key) => {
        this.setState({
            openDialogs: {
                ...this.state.openDialogs,
                [`dialog${key}`]: true,
            },
        });
    };

    handleClose = (key) => {
        this.setState({
            openDialogs: {
                ...this.state.openDialogs,
                [`dialog${key}`]: false,
            },
        });
    };

    handleChangeLayCanType = (index, value) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        newCargoOrder.loadingPortsMap[index].port.layCanType = value;

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    };

    hanleChangeAdditionalLayCanDetails = (index, value) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        newCargoOrder.loadingPortsMap[index].port.additionalLayCanDetails = value;

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    };

    render() {
        const errorLoadingPort = this.props.errorLoadingPort ? this.props.errorLoadingPort.messages[0] : '';
        const errorUnloadingPort = this.props.errorUnloadingPort ? this.props.errorUnloadingPort.messages[0] : '';

        const errorReadinessDate = this.props.errorReadinessDate ? this.props.errorReadinessDate.messages[0] : '';
        const errorCancellingDate = this.props.errorCancellingDate ? this.props.errorCancellingDate.messages[0] : '';

        const { loadingPortsMap, unloadingPortsMap } = this.props.cargoOrder;

        const actions = [
            <FlatButton
                label="Ok"
                primary
                onClick={() => {
                    const entries = Object.entries(this.state.openDialogs);
                    return entries.forEach(entrie => entrie[1] && this.handleClose(entrie[0].substr(-1)));
                }}
            />,
        ];

        return (<div>
            <div className='row'>
                <div className='column-left'>
                    Loading ports:
                </div>
                <div className='column-right'>
                    <RaisedButton
                        labelStyle={{ fontSize: '10px' }}
                        style={{ height: '25px', marginBottom: '10px' }}
                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                        label='Add new loading port'
                        onClick={() => this.addNewPort('loading')}
                        primary
                    />
                </div>
            </div>
            {loadingPortsMap && loadingPortsMap.map((portItem, key) => (
                <div key={key}>
                    <div
                        className="row"
                        style={{ background: `${portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                    >
                        <div className='column-left'>
                            {`Loading port - ${key + 1}`}
                        </div>
                    </div>
                    <div
                        className='row'
                        style={{ background: `${portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                    >
                        <div className='label'>{portItem.port.port}</div>
                    </div>
                    <div
                        className='row'
                        style={{ background: `${portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                    >
                        <LUportBlock
                            error={errorLoadingPort}
                            port={portItem.port}
                            typeOfPort='loading'
                            portKey={key}
                            changePort={this.changePort}
                            removePort={this.removePort}
                        />
                    </div>
                    <div
                        className="row"
                        style={{ marginBottom: '15px', background: `${portItem.sign === 'and' || key === 0 ? '#EEF8E4' : '#F5F5F5'}` }}
                    >
                        <div className='one-forth'>
                            <CreateNewRegion
                                typeOfPort='loading'
                                numberOfPort={key}
                                numberOrderTable={this.props.numberOrderTable}
                                cargoOrder={this.props.cargoOrder}
                            />
                        </div>
                        <div className="one-forth">
                            <RaisedButton
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                label='Laycan'
                                onClick={() => this.handleOpen(key)}
                                primary
                            />
                        </div>
                        <div className="one-forth" style={{ fontSize: '12px', display: 'block' }}>
                            <span>{getValueByLayCanType(portItem.port.layCanType).value}:</span>
                            <div>
                                {
                                    <span
                                        style={{
                                            fontSize: '12px',
                                            color: portItem.port.readinessDateOld ? '#f00' : 'unset',
                                        }}
                                    >
                                        {moment(portItem.port.readinessDate).utc().format('DD-MM-YYYY')} ---
                                    </span>
                                }
                                {
                                    portItem.port.cancellingDateOld ?
                                        <span style={{ color: '#f00', fontSize: '12px' }}>
                                            {moment(portItem.port.cancellingDateOld).format('DD-MM-YYYY')}
                                        </span>
                                        :
                                        <span style={{ fontSize: '12px' }}>
                                            {moment(portItem.port.cancellingDate).utc().format('DD-MM-YYYY')}
                                        </span>
                                }
                            </div>
                            {portItem.port.validUntil && (
                                <div style={{ marginTop: '4px' }}>
                                    <span style={{ color: '#666' }}>Valid until: </span>
                                    <span>{moment(portItem.port.validUntil).utc().format('DD-MM-YYYY')}</span>
                                </div>
                            )}
                        </div>
                        <div className="one-forth" style={{ fontSize: '12px', display: 'block' }}>
                            <span>Details:</span>
                            <div>{portItem.port.additionalLayCanDetails}</div>
                        </div>

                        <Dialog
                            title="Readiness/Cancelling dates"
                            actions={actions}
                            modal={false}
                            open={!!this.state.openDialogs[`dialog${key}`]}
                            onRequestClose={() => this.handleClose(key)}
                        >
                            <div className='row'>
                                <SelectField
                                    hintText='LayCan type'
                                    value={portItem.port.layCanType}
                                    style={{ fontSize: '13px', width: '200px' }}
                                    onChange={(_e, _i, v) => this.handleChangeLayCanType(key, v)}
                                    autoWidth
                                >
                                    {LAYCAN_TYPES
                                        .map(item => <MenuItem key={item.key} value={item.key} primaryText={item.value} />)
                                    }
                                </SelectField>
                                <TextField
                                    className='additionalLayCanDetails'
                                    value={portItem.port.additionalLayCanDetails || ''}
                                    hintText='Details (optional)'
                                    style={{ marginLeft: '10px', width: '250px' }}
                                    hintStyle={{ fontSize: '13px' }}
                                    onChange={e => this.hanleChangeAdditionalLayCanDetails(key, e.target.value)}
                                />
                            </div>
                            <DateRangeSelector
                                from={portItem.port.readinessDate || null}
                                until={portItem.port.cancellingDate || null}
                                fromLabel="Readiness date"
                                untilLabel="Cancelling date"
                                fromHint={new Date(portItem.port.readinessDateOld)}
                                untilHint={portItem.port.cancellingDateOld}

                                errorFrom={errorReadinessDate}
                                errorUntil={errorCancellingDate}
                                onChange={range => this.changePort(
                                    loadingPortsMap.indexOf(portItem),
                                    'loading',
                                    { readinessDate: range.from, cancellingDate: range.until },
                                )}
                            />
                            <div className='row' style={{ marginTop: '10px' }}>
                                <div className='column-left'>
                                    <div className="label">Valid until:</div>
                                </div>
                            </div>
                            <div className="row full" style={{ display: 'flex', alignItems: 'center' }}>
                                <DatePicker
                                    autoOk
                                    value={portItem.port.validUntil ? moment.utc(portItem.port.validUntil).local(true).toDate() : null}
                                    id={`validUntil-${key}`}
                                    hintText="Valid until"
                                    textFieldStyle={{ fontSize: '13px', width: '120px' }}
                                    onChange={(e, date) => {
                                        const inUtc = date ? moment(date).utcOffset(0, true).set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 }).toDate() : '';
                                        this.changePort(
                                            loadingPortsMap.indexOf(portItem),
                                            'loading',
                                            { validUntil: inUtc },
                                        );
                                    }}
                                    formatDate={date => moment(date).format('DD-MM-YYYY')}
                                />
                                {portItem.port.validUntil && (
                                    <FlatButton
                                        label="Clear"
                                        secondary
                                        style={{ marginLeft: '10px', height: '36px', minWidth: '60px' }}
                                        labelStyle={{ fontSize: '12px' }}
                                        onClick={() => {
                                            this.changePort(
                                                loadingPortsMap.indexOf(portItem),
                                                'loading',
                                                { validUntil: '' },
                                            );
                                        }}
                                    />
                                )}
                            </div>
                        </Dialog>
                    </div>
                </div>
            ))}

            <hr />

            <div className='row'>
                <div className='column-left'>
                    Unloading ports:
                </div>
                <div className='column-right'>
                    <RaisedButton
                        labelStyle={{ fontSize: '10px' }}
                        style={{ height: '25px', marginBottom: '10px' }}
                        buttonStyle={{ height: '25px', lineHeight: '25px' }}
                        label='Add new unloading port'
                        onClick={() => this.addNewPort('unloading')}
                        primary
                    />
                </div>
            </div>
            {
                unloadingPortsMap && unloadingPortsMap.map((portItem, key) => (
                    <div key={key}>
                        <div
                            className="row"
                            style={{ background: `${portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                        >
                            <div className='column-left'>
                                {`Unloading port - ${key + 1}`}
                            </div>
                        </div>
                        <div
                            className='row'
                            style={{ background: `${portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                        >
                            <div className='label'>{portItem.port.port}</div>
                        </div>
                        <div
                            className='row'
                            style={{ background: `${portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                        >
                            <LUportBlock
                                error={errorUnloadingPort}
                                port={portItem.port}
                                typeOfPort='unloading'
                                portKey={key}
                                changePort={this.changePort}
                                removePort={this.removePort}
                            />
                        </div>
                        <div
                            className="row"
                            style={{ marginBottom: '15px', background: `${portItem.sign === 'and' || key === 0 ? '#E8F0F8' : '#F5F5F5'}` }}
                        >
                            <div className='one-forth'>
                                <CreateNewRegion
                                    typeOfPort='unloading'
                                    numberOfPort={key}
                                    numberOrderTable={this.props.numberOrderTable}
                                    cargoOrder={this.props.cargoOrder}
                                />
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>);
    }
}

export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];

        const errorUnloadingPort = cargoOrder.validateErrors.find(validateError => validateError.field === 'unloadingPort');

        const errorLoadingPort = cargoOrder.validateErrors.find(validateError => validateError.field === 'loadingPort');

        const errorReadinessDate = cargoOrder.validateErrors.find(validateError => validateError.field === 'readinessDate');

        const errorCancellingDate = cargoOrder.validateErrors.find(validateError => validateError.field === 'cancellingDate');

        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
            errorUnloadingPort,
            errorLoadingPort,
            errorReadinessDate,
            errorCancellingDate,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(LUports);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/LUPorts/LUports.jsx